module.exports = __webpack_public_path__ + "static/media/llamenos.fb6bddf5.svg";